export default "__VITE_ASSET__DU$JN0$F__"